<div class="">
  <div class="d-flex align-items-center justify-content-between head">
    <h5 class="">{{ isEdit ? 'Update Booking Limit' : 'Set Booking Limit' }}</h5>
    <p class="modal-close-btn" (click)="bsModalRef?.hide()" aria-label="Close">
      &times;
    </p>
  </div>

  <div>
    <div class="modal-body" [formGroup]="limitform">
      <p class="modal-body-text">
        Set up limit on booking for your Employee bookings on Clooper
      </p>
      <p class="modal-text-head sub mt-3">
        Booking Limit {{booking?.value === 'flight' ? '(per flight)' : '(per night)'}} <span class="text-danger">*</span>
        <fa-icon class="me-2 info-icon" [icon]="icons.info"></fa-icon>
      </p>

      <div class="flex-1">
        <input
          type="text"
          placeholder="Enter limit"
          class="input-number"
          formControlName="limitValue"
        />
      </div>
      <div class="col-12 form-input mb-3 ">
        <label class="  modal-text-head">
          Booking Type <span class="text-danger">*</span>
        </label>

        <select class="form-control" #booking formControlName="service_type" name="" id="">
          <option value="" selected>Select service type</option>
          <option value="accommodation" >Accomodation</option>
          <option value="flight" >Flight</option>
        </select>

    </div>
      <div class="col-12 form-input mb-3 ">
        <label class="modal-text-head">
          Currency
        </label>

        <select class="form-control"  formControlName="currency" name="" id="">
            <option value="" selected>Select currency</option>
            <option [value]="unit.code" *ngFor="let unit of currencies" >{{unit?.name}}</option>
        </select>


    </div>

      <p class="note">
        Note: An approval request will be sent by an employee if the set limit
        is breached.
      </p>
    </div>

    <div class="btn">
      <app-button
      dataTest="save-and-close-btn"
      [className]="'w-100'"
      [disabled]="loading"
      (onclick)="handleAddLimit()"
      warning
    >
      {{ loading ? "Saving..." : (isEdit ? 'Update' : 'Set') }}
    </app-button>
    </div>
  </div>
</div>
